<mat-card-header>
  <mat-card-title>検索結果</mat-card-title>
</mat-card-header>

<mat-card-content class="mat-card-style-search-result">
  <div class="table-responsive">
    <table mat-table multiTemplateDataRows id="dispData" [dataSource]="dataSource" matSort #sort1="matSort">
      <ng-container matColumnDef="select">
        <th mat-header-cell class="mat-header-cell-checkbox" *matHeaderCellDef>
          <mat-checkbox 
            (change)="$event ? this.masterToggle(selectionClaimCharge, dataSource) : null; onChangeSelection($event, selectionClaimCharge)"
            [checked]="selectionClaimCharge.hasValue() && isAllSelected(selectionClaimCharge, dataSource)"
            [indeterminate]="selectionClaimCharge.hasValue() && !isAllSelected(selectionClaimCharge, dataSource)" 
            [aria-label]="checkboxLabel(selectionClaimCharge, dataSource)"
            color="primary">
          </mat-checkbox>
        </th>
        <td mat-cell class="mat-cell-checkbox" *matCellDef="let e">
          <mat-checkbox 
            (click)="$event.stopPropagation()"
            (change)="$event ? this.selectionClaimCharge.toggle(e) : null; onChangeSelection($event, selectionClaimCharge)"
            [checked]="selectionClaimCharge.isSelected(e)" 
            [aria-label]="checkboxLabel(selectionClaimCharge, dataSource, e)" 
            color="primary">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="firstSrvctrNo">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約番号
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.firstSrvctrNo }}
        </td>
      </ng-container>

      <ng-container matColumnDef="shiyouBashoJusho">
        <th mat-header-cell class="border-bottom-double jusho-width" *matHeaderCellDef mat-sort-header>
          使用場所住所
        </th>
        <td mat-cell class="jusho-width" *matCellDef="let e">
          {{ e.empposInfo.description }}{{ e.empposInfo.mptAname }}{{ e.empposInfo.townAreaName }}
          {{ e.empposInfo.ooazaName }}{{ e.empposInfo.bantiGoubunptgouAname }}
          {{ e.empposInfo.supadrKanjiAname1 }}{{ e.empposInfo.yagouAname }}
        </td>
      </ng-container>

      <ng-container matColumnDef="visitName">
        <th mat-header-cell class="border-bottom-double name-width" *matHeaderCellDef mat-sort-header>
          お客さま名
        </th>
        <td mat-cell class="name-width" *matCellDef="let e">
          {{ e.ctrperInfo.visitName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="enerugiShubetsu">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          エネルギー種別／熱量
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.energyClsfyCodeaname }}{{ e.pipe }}{{ e.description.heatAname }}{{ e.unitHeat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="gyoshuLargebunruiAname">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          業種（大分類）
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.gyoshuLargebunruiAname }}
        </td>
      </ng-container>

      <ng-container matColumnDef="prdGoodsRyaku">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          料金プラン名
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.prdGoodsRyaku }}
        </td>
      </ng-container>

      <ng-container matColumnDef="combinedcontractDivCodeaname">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          総合区分
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.combinedcontractDivCodeaname }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ctrstrDate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約開始日
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.ctrstrDate | dateString }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ctrendDate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約廃止日
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.description.ctrendDate | dateString }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usingVisitKnjnm">
        <th mat-header-cell class="border-bottom-double name-width" *matHeaderCellDef mat-sort-header>
          使用者お客さま名
        </th>
        <td mat-cell class="name-width" *matCellDef="let e">
          {{ e.userInfo.usingVisitKnjnm }}
        </td>
      </ng-container>

      <ng-container matColumnDef="extLinkId">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          お客さま番号
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.ctrperInfo.extLinkId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="extCnnctNo">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          供給地点特定番号
        </th>
        <td mat-cell *matCellDef="let e">
          {{ e.empposInfo.extCnnctNo }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
    </table>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="end center">
    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button color="primary" class="btn"
        (click)="onClickOk(selectionClaimCharge)">
        OK
      </button>
    </mat-card-actions>

    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button color="primary" class="btn"
        (click)="onClickCancel()">
        閉じる
      </button>
    </mat-card-actions>
  </div>
</mat-card-content>